import React from 'react'
import './Tail.css'
import SetupAddItem from './SetupAddItem'

export default function Tail({items, addItem}) {
  const deg = Math.min(32, (32 / items) * 1.0)
  const dynamicStyle = {
    '--wizard-arrow-angle': `${deg}deg`
  }

  return (
    <div className='wizardTail' style={dynamicStyle}>
      <div className='wizardUpperTail' > 
        <SetupAddItem onClick={addItem} />
      </div>
      <div className='wizardLowerTail' />
    </div>
  )
}
